import { Box, Stack } from '@chakra-ui/react';
import { JSX } from 'react';
import { formatDateTime } from 'shared-components';
import { EventBookingStatus, ICalendlyInterviewFulfilmentData } from 'api-paths-cas';
import BaseFulfilmentDataRenderer, { FulfilmentRendererProps } from './BaseFulfilmentDataRenderer';

export default function CalendlyInterviewFulfilmentRenderer(props: FulfilmentRendererProps): JSX.Element | null {
  const { fulfilmentData, internalData } = props;
  const data = fulfilmentData as ICalendlyInterviewFulfilmentData | null;
  const isBooked = data?.bookingStatus === EventBookingStatus.BOOKED;
  const hasInternalFiles = internalData?.urls && internalData.urls.length > 0;

  if (!isBooked && !hasInternalFiles) {
    return null;
  }

  return (
    <Stack spacing={1}>
      {isBooked && data?.startDate && (
        <Box fontSize="sm" color="muted">
          {`Booked for ${formatDateTime(new Date(data.startDate))}`}
        </Box>
      )}
      <BaseFulfilmentDataRenderer {...props} />
    </Stack>
  );
}
